<template>
    <div>
        <card>
            <template v-slot:header>
                    <h4 class="d-inline">تنـظیـمـات تیکت</h4>
                    <hr />
            </template>
            <template v-slot:content>
                
                   
                    
                        <div class="row" v-if="render">
                            <div class="col-md-4 col-12">
                                <div class="mt-2 text-center">
                                    <small id="LblIsSmsTicket" class="d-none">فعال کردن پیامک تیکت جدید</small>
                                    <span class="form-control p-1">
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input InputText " id="IsSmsTicket" @change="ChangeSettingTicket($event)" v-model="DataAxiosSettingTicket.IsSmsTicket" />
                                            <label class="custom-control-label" for="IsSmsTicket">فعال کردن پیامک تیکت جدید</label>
                                        </div>
                                    </span>
                                </div>
                            </div>
                            <div class="col-md-4 col-12">
                                <div class="mt-2 text-center">
                                    <small id="LblIsNotificationTicket" class="d-none">فعال کردن اعلان تیکت جدید</small>
                                    <span class="form-control p-1">
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input InputText " id="IsNotificationTicket"  @change="ChangeSettingTicket($event)" v-model="DataAxiosSettingTicket.IsNotificationTicket" />
                                            <label class="custom-control-label" for="IsNotificationTicket">فعال کردن اعلان تیکت جدید</label>
                                        </div>
                                    </span>
                                </div>
                            </div>
                            <div class="col-md-4 col-12" v-if="$IsCustomer() == false">
                                <div class="mt-2 text-center">
                                    <small id="LblSmsReferenceTicket" class="d-none">فعال کردن پیامک ارجاع تیکت</small>
                                    <span class="form-control p-1">
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input InputText " id="SmsReferenceTicket"  @change="ChangeSettingTicket($event)" v-model="DataAxiosSettingTicket.SmsReferenceTicket" />
                                            <label class="custom-control-label" for="SmsReferenceTicket">فعال کردن پیامک ارجاع تیکت</label>
                                        </div>
                                    </span>
                                </div>
                            </div>
                            <div class="col-md-4 col-12" v-if="$IsCustomer() == true">
                                <div class="mt-2 text-center">
                                    <small id="LblSmsChangeTicketStatus" class="d-none">فعال کردن پیامک تغییر وضعیت تیکت</small>
                                    <span class="form-control p-1">
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input InputText " id="SmsChangeTicketStatus"  @change="ChangeSettingTicket($event)" v-model="DataAxiosSettingTicket.SmsChangeTicketStatus" />
                                            <label class="custom-control-label" for="SmsChangeTicketStatus">فعال کردن پیامک تغییر وضعیت تیکت</label>
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
               
            </template>
        </card>
    </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
export default {
  components: { Card },
    data(){
        return {
            DataAxiosSettingTicket:{},
            render: true

        }
        
    },
    methods:{
       
        GetSettingTicket(){
             let DataAxios_GetSettingTicket={
                ArryfildValue: {},
                Method: "post",
                Action: "MyProfile/GetSettingTicket",
                Token: this.$session.get("Token")
            }
            DataAxios_GetSettingTicket.ArryfildValue={tblUserId:this.$session.get("UserInfo").tblUserId}
            this.$PostData(DataAxios_GetSettingTicket).then(data=>{
                this.DataAxiosSettingTicket.IsNotificationTicket=data.result.isNotificationTicket
                this.DataAxiosSettingTicket.IsSmsTicket=data.result.isSmsTicket
                this.DataAxiosSettingTicket.SmsReferenceTicket =data.result.smsReferenceTicket
                this.DataAxiosSettingTicket.SmsChangeTicketStatus =data.result.smsChangeTicketStatus
            }).finally(()=>{
                this.render = false
                this.$nextTick(() => {
                    this.render = true
                })
            })
        },
        ChangeSettingTicket(e){
            // console.log(e.target.checked);
            let DataAxios_UpdateSettingTicket={
                ArryfildValue: {},
                Method: "put",
                Action: "MyProfile/UpdateSettingTicket",
                Token: this.$session.get("Token")
            }
            DataAxios_UpdateSettingTicket.ArryfildValue=this.DataAxiosSettingTicket
            DataAxios_UpdateSettingTicket.ArryfildValue.tblUserId=this.$session.get("UserInfo").tblUserId
            this.$PostData(DataAxios_UpdateSettingTicket).then(data=>{
                this.$toasted.success('تغیرات بر روی تیک ها اعمال گردید', { duration: 1000},);
            }).finally(()=>{

            })
        }
    },
    mounted(){
        this.GetSettingTicket();
    },
}
</script>
<style scoped>

</style>